import { inject, ref, nextTick } from 'vue';
import { securedWrap } from '@mop/shared/utils/securedWrap';

export default function useUiFormElement(props: any) {
  const register = inject('register') as (component: any) => void;
  const validationErrors = ref<string[]>([]);
  const loadingRef = ref(false);

  async function validate(): Promise<boolean> {
    await nextTick();
    validationErrors.value = [];
    const rules: Function[] = props.rules as Function[];
    if (!rules || rules.length === 0) {
      return true;
    }
    loadingRef.value = true;
    validationErrors.value = await rules.reduce(async (errorMessages: Promise<string[]>, rule: Function) => {
      // this sequence makes execution paralel, do not change the order of await calls
      const validationResult: string = await rule(props.modelValue);
      const previousValue: string[] = await errorMessages;
      if (typeof validationResult === 'string' && validationResult) {
        previousValue.push(validationResult);
      }
      return previousValue;
    }, Promise.resolve([]));
    loadingRef.value = false;
    return validationErrors.value.length === 0;
  }

  return securedWrap({
    validationErrors,
    register,
    validate,
    loadingRef,
  });
}
